import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { ProcurementSettings, ProcurementSettingsUpdateDTO } from '../interfaces/procurement/procurementSettings.interface';

export const ProcurementSettingsService = {
  getByInstitution: async (institutionId: string): Promise<ProcurementSettings> =>
    (await axios.get(ENDPOINTS.PROCUREMENT_SETTINGS.GET_BY_INSTITUTION(institutionId))).data,
  upsert: async (institutionId: string, dto: ProcurementSettingsUpdateDTO): Promise<ProcurementSettings> =>
    (await axios.put(ENDPOINTS.PROCUREMENT_SETTINGS.UPSERT(institutionId), dto)).data,
};
